import { render, staticRenderFns } from "./EmailAutomationBuilder.vue?vue&type=template&id=72feaf43&scoped=true"
import script from "./EmailAutomationBuilder.vue?vue&type=script&lang=js"
export * from "./EmailAutomationBuilder.vue?vue&type=script&lang=js"
import style0 from "./EmailAutomationBuilder.vue?vue&type=style&index=0&id=72feaf43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72feaf43",
  null
  
)

export default component.exports